<template>
  <tender-form-label :key="index" 
    :label="options.Name"
    :prop="options.Key"
    :rules="rules"
  >
    <bear-traffic-upload-dialog v-if="isTraffic" v-model="form[options.Key]" @input="inputChangeHandle" :accept="param.accept"></bear-traffic-upload-dialog>
    <bear-upload-dialog v-else v-model="form[options.Key]" @input="inputChangeHandle" :accept="param.accept"></bear-upload-dialog>
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import BearUploadDialog from '~@/upload-dialog/src'
import BearTrafficUploadDialog from '~@/traffic-upload-dialog/src'
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
import tenderHook from "../../../js/hooks";
export default {
  name: 'FormInputDefault',
  mixins: [mixForFormItem],
  components: {BearUploadDialog, BearTrafficUploadDialog},
  data() {
    return {
    }
  },
  computed: {
    isTraffic () {
      return __type__ === 'traffic'
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        this.setFormItemValue(options.Value || [])
      }).catch(() => null)
    },
    inputChangeHandle() {
      this.doSelectEvent(true)
      this.doValidate()
    },
    doSelectEvent(isOnlySet) {
      let { options = {} } = this;
      let { Refs = [] } = options;
      Refs.forEach((eRef) => {
        let [type, ...args] = eRef;
        switch (type) {
          case "setFormItemWithCustom":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [type, ...x] = args;
                console.log(form[Key], Key, this.form, 333);
                tenderHook.setFormItemWithCustom(this, type, options, ...x);
              });
              // tenderHook.refEvent(false, this);
            }
            break;
          case "houseHooks":
          case "trafficHooks":
            tenderHook.refEvent(isOnlySet, this)
            // if(!isOnlySet) {
            // }
            break;
        }
      });
      this.doValidate();
    },
  }
}
</script>
